module.exports = __webpack_public_path__ + "img/guide_pic.962e5390.png";